import { axiosClient } from '@/shared/apis/config';

export interface ReportUploadFailureRequest {
  // 기존 필드
  fileName: string;
  fileSize?: number;
  contentId?: number;
  spaceId?: number;
  folderId?: number;
  errorMessage?: string;
  errorReason?: string;
  uploadPath?: string;

  // 신규 — 분류 결과 (BE grouping 키)
  /** 분류기 결과 i18nKey. errorReason 과 함께 BE 측 grouping/필터링 보조 키. */
  i18nKey?: string;

  // 신규 — 파일/에러 메타
  /** File.type (예: "video/mp4"). 코덱·컨테이너별 실패율 분석에 사용. */
  mimeType?: string;
  /** 파일 확장자 (소문자, 점 제외; 예: "mp4"). */
  fileExtension?: string;
  /** Chromium MediaError code 등 raw 에러 코드. classifier raw.code 에서 채움. */
  errorCode?: number | string;
  /** S3 등 HTTP 응답 코드 (예: 403). classifier raw.httpStatus 에서 채움. */
  httpStatus?: number;

  // 신규 — 클라이언트 환경
  /** navigator.userAgent. SSR 환경에서는 undefined. */
  userAgent?: string;
  /**
   * 같은 업로드 시도(retry 포함) dedupe 키. 호출자가 재시도마다 같은 UUID 를 reuse 하면
   * BE 가 retry attempt 들을 하나의 시도로 묶어 분석 가능. 미지정 시 매 호출마다 새 UUID 생성.
   */
  clientSessionId?: string;
  /** 같은 업로드 시도 내 retry 횟수. 현재 retry 추적 미구현이므로 0 또는 undefined. */
  retryCount?: number;
  /**
   * 업로드 시작 ISO timestamp. 현재 호출자가 시작 시각을 보존하지 않아 reserved.
   * 의미상 "failedAt" 에 가까우므로 향후 별도 작업에서 필드 의미·이름 재정비.
   */
  uploadStartedAt?: string;

  // 신규 — 분산 추적
  /**
   * client-generated trace UUID. 별도 PR 에서 axios interceptor + BE LoggingInterceptor
   * 양측 변경 후 실제 분산 traceId 와 결합 예정. 현재는 클라이언트 단독 식별자.
   */
  traceId?: string;
}

export const postReportUploadFailureApi = async (
  form: ReportUploadFailureRequest,
) => {
  try {
    await axiosClient.post('/v1.0/content/report-upload-failure', form);
  } catch (e) {
    // 실패 리포트 자체가 실패해도 원래 업로드 흐름에 영향을 주지 않음
    console.error('[Upload] 업로드 실패 리포트 전송 실패:', e);
  }
};
